import React from 'react';
import { createRoot } from 'react-dom/client';
import './config/theme/tokens.css';
import './index.css';
import App from './App';
// Loaded after App (and therefore after App.css) so the legacy-hex → token
// bridge is the last word on any conflicting declaration.
import './config/theme/bridge.css';
// Responsive rules load last so their media queries win over base layout.
import './config/theme/responsive.css';
// Motion after everything else: it only sets `animation`/`transition`/`transform`,
// and loading it last means it never has to fight an earlier declaration with
// `!important` — several controls above set `outline: none` or their own
// transition shorthand.
import './config/theme/motion.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import Store from './store';
import { BrowserRouter as Router } from 'react-router-dom';
import { registerDeviceForPush } from './config/firebase/firebase';

// Register the service worker, then register this device for push on EVERY boot.
// Registration is deliberately not tied to login (login goes straight to
// SynapseAuth) and is idempotent server-side, so it also self-heals a device
// whose token rotated or whose row was pruned. No-ops when not signed in.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then(function () {
      // Check if the service worker is active
      return navigator.serviceWorker.ready;
    })
    .then(function (registration) {
      navigator.serviceWorker.onmessage = () => {};
      return registerDeviceForPush(registration);
    })
    .catch(function () {});
}

// const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <Router basename="/">
    <Provider store={Store}>
      {/* <AgoraRTCProvider client={client}> */}
      <App />
      {/* </AgoraRTCProvider>¿ */}
    </Provider>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
